import { useSyncUser } from "./hooks/useSyncUser";
import Router from "./routes/routes";

export default function App() {
  useSyncUser();
 
  return <Router />;
};